import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ToggleButton from "../../components/ToggleButton";
import { RootState } from "../../redux/store";
import {
  ONBORADING_SCREEN,
  PRIVACY_POLICY,
  TERMS_OF_USE,
  UPDATE_EMAIL,
  UPDATE_PASSWORD,
} from "./../../navigation/Constants";
import {
  deleteMemberPushToken,
  getMemberPremiumStatus,
  updateSettings,
} from "./../../services/memberService";
import { resetUserData, setUserData } from "./../../redux/member";
import account, { freezAccount } from "../../services/accountService";
import { deleteMemberAccount } from "./../../services/accountService";
import { resetMoodData } from "../../redux/mood";
import { reset } from "../../redux/app";
import { resetSignupQuestions } from "../../redux/signupQuestions";
import { resetSignupData } from "../../redux/signup";
import { resetCarpet } from "../../redux/carpet";
import NiceModal from "@ebay/nice-modal-react";

import usePrepareLink from "../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../const/router";
import LoadingIndiactorModal from "../../components/modals/LoadingIndicatorModal";
import { recordGaEvent } from "../../helpers/GoogleAnalytics";
import {
  GAEventNames,
  GACategoryName,
  GAActions,
  GAUniqueEventIds,
} from "../../helpers/Enums";
import { sendMessageToWebview } from "../../services/native";

const Settings: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const member = useSelector((state: RootState) => state.member);
  const { hubConnection } = useSelector((state: RootState) => state.app);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const clearReduxStoreDate = () => {
    dispatch(resetUserData());
    dispatch(resetMoodData());
    dispatch(reset());
    dispatch(resetSignupQuestions());
    dispatch(resetSignupData());
    dispatch(resetCarpet());
  };

  const recordEvent = (
    element: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    let { target } = element;
    let anchorElement = target as HTMLAnchorElement;
    let label =
      anchorElement.textContent !== null ? anchorElement.textContent : "";
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.ACCOUNT_SETTING,
      GAActions.CLICK,
      label,
      GAUniqueEventIds.APP_ENGAGMENT,
    );
  };

  const logout = () => {
    if (window.platform === "android" || window.platform === "ios") {
      deleteMemberPushToken(member.memberCode);
    }
    account.logout();
    clearReduxStoreDate();
    hubConnection?.invoke("connectionClosed", member.memberCode);
    hubConnection?.stop();
    history.replace(ONBORADING_SCREEN);
  };

  const freezAndLogout = async () => {
    NiceModal.hide("action_modal");
    const { data } = await freezAccount(member.memberCode);
    dispatch(setUserData({ ...data, isFreezedAccount: data.isFreezedAccount }));

    recordGaEvent(
      GAEventNames.APP_ACTIONS,
      GACategoryName.PROFILE_ACTIONS,
      GAActions.PROFILE_FREEZE,
      "freeze",
      GAUniqueEventIds.APP_ACTIONS,
    );
    // logout();
  };

  const deleteAccountAndLogout = async () => {
    NiceModal.hide("action_modal");
    try {
      const res = await deleteMemberAccount();
      if (res.status === 204) {
        recordGaEvent(
          GAEventNames.APP_ACTIONS,
          GACategoryName.PROFILE_ACTIONS,
          GAActions.PROFILE_DELETE,
          "delete",
          GAUniqueEventIds.APP_ACTIONS,
        );
        logout();
        NiceModal.show("error_modal", {
          errorContent: "הפרטים שלך נמחקו בהצלחה",
        });
      }
    } catch (error: any) {
      console.log(error);
      NiceModal.show("error_modal", {
        errorContent: "שגיאה לא צפויה בפעולת המחיקה",
      });
    }
  };

  const isMobile = () => {
    if (window.platform === "ios" || window.platform === "android") {
      return true;
    }
    return false;
  };

  const redirectToTermsOfUse = () => {
    history.push(TERMS_OF_USE);
  };

  const redirectToPrivacyPolicy = () => {
    history.push(PRIVACY_POLICY);
  };

  const confirmLogout = () => {
    NiceModal.show("action_modal", {
      onNext: logout,
      headerTitle: "התנתקות",
      contentTitle:
        "בכניסה הבאה לחשבון יהיה צורך להכניס מחדש את המייל והסיסמה שלך. האם להמשיך?",
      seconderyButtonText: "בעצם לא",
      primaryButtonText: "כן, אני רוצה להתנתק",
      showCloseButton: true,
      showSeconderyButton: true,
    });
  };

  // const alertDeleteAccount = () => {
  //   NiceModal.show("action_modal", {
  //     onNext: () => {
  //       NiceModal.hide("action_modal");
  //     },
  //     headerTitle:
  //       "לא ניתן למחוק את הפרופיל שלך משושק'ה, כיוון שרכשת מנוי בתשלום.",
  //     contentTitle: (
  //       <>
  //         <p>
  //           כדי למחוק את הפרופיל שלך, ראשית יש לבטל את המנוי בתשלום
  //           <br /> ורק לאחר מכן למחוק את הפרופיל.
  //         </p>
  //         <span>לביטול המנוי בתשלום, </span>
  //         {isMobile() ? (
  //           <a
  //             style={{ cursor: "pointer" }}
  //             onClick={() =>
  //               sendMessageToWebview("open-store-subscription-settings")
  //             }
  //           >
  //             {" "}
  //             יש ללחוץ כאן{" "}
  //           </a>
  //         ) : (
  //           <span>
  //             יש להיכנס לאפליקציית שושק'ה בטלפון הסלולארי, ללחוץ על "פרופיל" ועל
  //             " מנוי פעיל" שם יימצא הקישור לביטול המנוי.
  //           </span>
  //         )}
  //         <p>
  //           לסיוע, אנא כתבו לנו ל-{" "}
  //           <a style={{ color: "blue" }} href="mailto:shoshke@motke.co.il">
  //             shoshke@motke.co.il
  //           </a>
  //         </p>
  //       </>
  //     ),
  //     primaryButtonText: "הבנתי",
  //     showCloseButton: true,
  //     showSeconderyButton: true,
  //     isDeleteModal: true,
  //   });
  // };

  const alertFreezeAccount = () => {
    NiceModal.show("action_modal", {
      onNext: () => {
        NiceModal.hide("action_modal");
      },
      // headerTitle: "לא ניתן להקפיא את הפרופיל שלך משושק'ה, כיוון שרכשת מנוי בתשלום.",
      headerTitle: "לא ניתן להקפיא את החשבון",
      contentTitle: (
        <>
          <p>
            <span>לא ניתן להקפיא את החשבון, מכיוון שקיים מנוי בתשלום.</span>
            <br />
            <span>
              על מנת להקפיא את החשבון, עליך לבטל קודם את המנוי בתשלום.
            </span>
          </p>

          {/* <p>
                כדי להקפיא את הפרופיל שלך, ראשית יש לבטל את המנוי בתשלום
                <br /> ורק לאחר מכן למחוק את הפרופיל.
              </p>
           */}
          {isMobile() && (
            <div>
              <span>לביטול המנוי בתשלום, </span>
              <a
                style={{ cursor: "pointer" }}
                onClick={() =>
                  sendMessageToWebview("open-store-subscription-settings")
                }
              >
                {" "}
                יש ללחוץ כאן{" "}
              </a>
            </div>
          )}
          <p style={{ margin: "0" }}>
            לסיוע, אנא כתבו לנו ל-{" "}
            <a style={{ color: "blue" }} href="mailto:shoshke@motke.co.il">
              shoshke@motke.co.il
            </a>
          </p>
        </>
      ),
      primaryButtonText: "הבנתי",
      showCloseButton: true,
      showSeconderyButton: true,
      isDeleteModal: true,
    });
  };

  const confirmFreezAccount = async () => {
    toggleLoader();
    try {
      const { data: isPremium } = await getMemberPremiumStatus();

      if (isPremium) {
        alertFreezeAccount();
      } else {
        NiceModal.show("action_modal", {
          onNext: freezAndLogout,
          headerTitle: "האם להקפיא את החשבון?",
          contentTitle:
            "כשהחשבון מוקפא אנשים לא יראו את הפרופיל שלך ולא יוכלו לשלוח לך הודעת. את ההקפאה תמיד אפשר לבטל באמצעות כניסה רגילה לחשבון.",
          seconderyButtonText: "התחרטתי",
          primaryButtonText: "מצויין, זה מה שאני רוצה",
          showCloseButton: true,
          showSeconderyButton: true,
        });
      }
    } catch (error: any) {
      console.log(error);
      NiceModal.show("error_modal", {
        errorContent: "שגיאה לא צפויה בפעולת בדיקת המנוי",
      });
    }
    toggleLoader();
  };

  // const confirmFreezAccount = () => {
  //   NiceModal.show("action_modal", {
  //     onNext: freezAndLogout,
  //     headerTitle: "האם להקפיא את החשבון?",
  //     contentTitle:
  //       "כשהחשבון מוקפא אנשים לא יראו את הפרופיל שלך ולא יוכלו לשלוח לך הודעת. את ההקפאה תמיד אפשר לבטל באמצעות כניסה רגילה לחשבון.",
  //     seconderyButtonText: "התחרטתי",
  //     primaryButtonText: "מצויין, זה מה שאני רוצה",
  //     showCloseButton: true,
  //     showSeconderyButton: true,
  //   });
  // };

  // const confirmFreezAccount = () => {
  //   NiceModal.show("action_modal", {
  //     onNext: freezAndLogout,
  //     headerTitle: "האם להקפיא את החשבון?",
  //     contentTitle:
  //       "כשהחשבון מוקפא אנשים לא יראו את הפרופיל שלך ולא יוכלו לשלוח לך הודעת. את ההקפאה תמיד אפשר לבטל באמצעות כניסה רגילה לחשבון.",
  //     seconderyButtonText: "התחרטתי",
  //     primaryButtonText: "מצויין, זה מה שאני רוצה",
  //     showCloseButton: true,
  //     showSeconderyButton: true,
  //   });
  // };

  const alertDeleteAccount = () => {
    NiceModal.show("action_modal", {
      onNext: () => {
        NiceModal.hide("action_modal");
      },
      // headerTitle: "לא ניתן למחוק את החשבון, כיוון שרכשת מנוי בתשלום.",
      headerTitle: "לא ניתן למחוק את החשבון",

      contentTitle: (
        <>
          <p>
            <span>לא ניתן למחוק את החשבון, מכיוון שקיים מנוי בתשלום.</span>
            <br />
            <span>על מנת למחוק את החשבון, עליך לבטל קודם את המנוי בתשלום.</span>
          </p>

          {/* <p>
            כדי למחוק את הפרופיל שלך, ראשית יש לבטל את המנוי בתשלום
            <br /> ורק לאחר מכן למחוק את הפרופיל.
          </p> */}
          {isMobile() && (
            <div>
              <span>לביטול המנוי בתשלום, </span>
              <a
                style={{ cursor: "pointer" }}
                onClick={() =>
                  sendMessageToWebview("open-store-subscription-settings")
                }
              >
                {" "}
                יש ללחוץ כאן{" "}
              </a>
            </div>
          )}
          <p style={{ margin: "0" }}>
            לסיוע, אנא כתבו לנו ל-{" "}
            <a style={{ color: "blue" }} href="mailto:shoshke@motke.co.il">
              shoshke@motke.co.il
            </a>
          </p>
        </>
      ),
      primaryButtonText: "הבנתי",
      showCloseButton: true,
      showSeconderyButton: true,
      isDeleteModal: true,
    });
  };

  const confirmDeleteAccount = async () => {
    toggleLoader();
    try {
      const { data: isPremium } = await getMemberPremiumStatus();

      if (isPremium) {
        alertDeleteAccount();
      } else {
        NiceModal.show("action_modal", {
          onNext: () => {
            NiceModal.hide("action_modal");
          },
          onCancel: deleteAccountAndLogout,
          headerTitle: "האם למחוק את החשבון לצמיתות?",
          contentTitle: (
            <>
              {" "}
              <p>כל הפרטים שלך יימחקו משושק'ה, ללא אפשרות שחזור.</p>
              <p>אם יש לך מנוי פרימיום, אפשר לבטל אותו דרך חנות האפליקציות.</p>
            </>
          ),
          seconderyButtonText: "כן, למחוק לצמיתות",
          primaryButtonText: "בעצם לא",
          showCloseButton: true,
          showSeconderyButton: true,
          isDeleteModal: true,
        });
      }
    } catch (error: any) {
      console.log(error);
      NiceModal.show("error_modal", {
        errorContent: "שגיאה לא צפויה בפעולת בדיקת המנוי",
      });
    }

    toggleLoader();
  };

  const handleUpdateMailNotfication = async () => {
    try {
      toggleLoader();
      await updateSettings(member.memberCode, "SentNotificationToMail");
      member.sentNotificationToMail = !member.sentNotificationToMail;
      dispatch(setUserData(member));
      toggleLoader();
    } catch (error: any) {
      console.error(error);
    }
  };

  const handleUpdatePhoneNotfication = async () => {
    try {
      toggleLoader();
      await updateSettings(member.memberCode, "SentNotificationToPhone");
      member.sentNotificationToPhone = !member.sentNotificationToPhone;
      dispatch(setUserData(member));
      toggleLoader();
    } catch (error: any) {
      console.error(error);
    }
  };

  const premiumMessagelink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
    },
    keepOldQuery: true,
  });

  const handleUpdateShowMeAsOffline = async () => {
    toggleLoader();
    try {
      const { data: isPremium } = await getMemberPremiumStatus();

      if (isPremium) {
        await updateSettings(member.memberCode, "ShowMeAsOffline");
        member.showMeAsOffline = !member.showMeAsOffline;
        dispatch(setUserData(member));

        toggleLoader();
      } else {
        toggleLoader();
        history.push(premiumMessagelink);
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const toggleLoader = () => {
    setShowLoader((oldValue) => !oldValue);
  };

  return (
    <>
      <div className="top_sec signup wf-section">
        <div className="signup_status_group">
          <h1 className="top_title edit">הגדרות</h1>
          <a
            href="#"
            onClick={() => history.goBack()}
            className="top_back signup w-inline-block"
          >
            <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
          </a>
        </div>
      </div>
      <div className="content_sec wf-section">
        <div className="login_sec setting w-form">
          <form
            id="email-form"
            name="email-form"
            data-name="Email Form"
            method="get"
          >
            <div className="form_field_content setting">
              <ul className="edit_info_list setting w-list-unstyled">
                <li className="edit_info_item setting">
                  <Link
                    to={UPDATE_EMAIL}
                    className="edit_info_link w-inline-block"
                  >
                    <div className="edit_link_info w-clearfix">
                      <h4 className="field_title setting">כתובת אימייל</h4>
                      <div
                        style={{ color: "#d83f35" }}
                        className="edit_ar_block w-clearfix"
                      >
                        {member.email}
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="edit_info_item setting">
                  <Link
                    to={UPDATE_PASSWORD}
                    className="edit_info_link w-inline-block"
                  >
                    <div className="edit_link_info w-clearfix">
                      <h4 className="field_title setting">סיסמה</h4>
                      <div
                        style={{ color: "#d83f35", whiteSpace: "nowrap" }}
                        className="edit_ar_block w-clearfix"
                      >
                        {"החלף סיסמה"}
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
              <ToggleButton
                title={"התראות למייל"}
                isToggledValue={Boolean(member.sentNotificationToMail)}
                subtitle={null}
                onclick={handleUpdateMailNotfication}
              />
              <ToggleButton
                title={"התראות בנייד"}
                isToggledValue={Boolean(member.sentNotificationToPhone)}
                subtitle={null}
                onclick={handleUpdatePhoneNotfication}
              />
              <ToggleButton
                title={"גלישה בסתר"}
                isToggledValue={Boolean(member.showMeAsOffline)}
                subtitle={
                  "כך אפשר לצפות בפרופילים בצורה אנונימית ומבלי להיראות במצב מחובר"
                }
                onclick={handleUpdateShowMeAsOffline}
                isPremiumFeature={true}
              />
            </div>
            <div
              className="form_field_content setting"
              style={{ textAlign: "right" }}
            >
              <ul className="edit_info_list setting w-list-unstyled">
                <li className="setting">
                  <a
                    // href="https://www.motke.co.il/%D7%AA%D7%A0%D7%90%D7%99-%D7%A9%D7%99%D7%9E%D7%95%D7%A9-%D7%A9%D7%95%D7%A9%D7%A7%D7%941"
                    // href="https://bounakir.webflow.io/terms"
                    // onClick={recordEvent}
                    href="#"
                    onClick={redirectToTermsOfUse}
                    className="edit_info_link w-inline-block"
                    target="_blank"
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">תנאי שימוש</h4>
                    </div>
                  </a>
                </li>
                <li className="setting">
                  <a
                    // href="https://www.motke.co.il/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA-%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA-%D7%A9%D7%95%D7%A9%D7%A7%D7%94"
                    // href="https://bounakir.webflow.io/privacy-policy"
                    // onClick={recordEvent}
                    href="#"
                    onClick={redirectToPrivacyPolicy}
                    className="edit_info_link w-inline-block"
                    target="_blank"
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">מדיניות פרטיות</h4>
                    </div>
                  </a>
                </li>
                <li className="setting">
                  <a
                    href="https://www.motke.co.il/%D7%A2%D7%96%D7%A8%D7%94"
                    onClick={recordEvent}
                    target={"_blank"}
                    className="edit_info_link w-inline-block"
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">עזרה</h4>
                    </div>
                  </a>
                </li>
                <li className="setting">
                  <a
                    href="https://www.motke.co.il/%D7%90%D7%95%D7%93%D7%95%D7%AA-%D7%A9%D7%95%D7%A9%D7%A7-%D7%94"
                    onClick={recordEvent}
                    className="edit_info_link w-inline-block"
                    target="_blank"
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">עלינו</h4>
                    </div>
                  </a>
                </li>

                <li className="setting">
                  <a
                    href="#"
                    className="edit_info_link w-inline-block"
                    onClick={confirmFreezAccount}
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">הקפאת חשבון</h4>
                    </div>
                  </a>
                </li>
                <li className="setting">
                  <a
                    href="#"
                    className="edit_info_link w-inline-block"
                    onClick={confirmDeleteAccount}
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">מחיקת חשבון</h4>
                    </div>
                  </a>
                </li>
                <li className="setting">
                  <a
                    href="#"
                    className="edit_info_link red w-inline-block"
                    onClick={confirmLogout}
                  >
                    <div className="edit_link_info">
                      <h4 className="settink_link_title">התנתק</h4>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
      {showLoader && <LoadingIndiactorModal text="" />}
    </>
  );
};

export default Settings;
